var TOUR = require('../../common/tours/funderDashboard');
var Promise = require('bluebird');

module.exports = function($scope, Tour, $state){
  var vm = this;

  vm.init = function(){
    vm.loading = true;

    var p = Promise.delay(1000).then(function(){
      vm.loading = false;
    })

    Tour.TriggerOn('foo', p);

    return p;
  }

  vm.init();

}
